export interface SubscriptionOption {
  name: string;
  id: string;
  description: string;
  price: number;
  subPrice: number;
}

export const MONTHLY_SUBSCRIPTION_ID = 'monthly';
export const MASTER_SUBSCRIPTION_ID = 'master';

export const SUBSCRIPTIONS: SubscriptionOption[] = [
  {
    name: 'Monthly',
    id: MONTHLY_SUBSCRIPTION_ID,
    description: '$249 one time registration fee + $39.95 a month (Starting in 30 days)',
    price: 24900,
    subPrice: 3995,
  },
  {
    name: "Master's",
    id: MASTER_SUBSCRIPTION_ID,
    description: '$300 one time registration fee + $100 a month (Starting in 30 days)',
    price: 30000,
    subPrice: 10000,
  },
];
